import * as ngCore from '@angular/core'

/**
 * Empty state component for the conversational assistant.
 * Displays a welcome message when no conversation is active.
 */
@ngCore.Component({
  selector: 'atn-assistant-empty-state',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {}
